import React, { useEffect, useRef } from 'react';
import { useRouter } from '@sls-react/routing';

interface Props {}

const ScrollRestoration: React.FC<Props> = () => {
  const router = useRouter();
  const cachedScrollPositions = useRef<number[][]>([]);

  useEffect(() => {
    if (!('scrollRestoration' in window.history)) {
      return;
    }

    window.history.scrollRestoration = 'manual';
    let shouldScrollRestore;

    router.events.on('routeChangeStart', () => {
      cachedScrollPositions.current.push([window.scrollX, window.scrollY]);
    });

    router.events.on('routeChangeComplete', (url, arg) => {
      if (shouldScrollRestore) {
        const { x, y } = shouldScrollRestore;
        window.scrollTo(x, y);
        shouldScrollRestore = false;
      }
    });

    router.beforePopState(() => {
      const popped = cachedScrollPositions.current.pop();
      if (!popped) {
        return true;
      }

      const [x, y] = popped;
      shouldScrollRestore = { x, y };

      return true;
    });
  }, []);

  return null;
};

export default ScrollRestoration;
